<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Web Customer Product'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
 <ng-container>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row>
                      <ion-col size="12" size-md="2" style="padding-top:25px;padding-left:10px">
                             <ion-row>
                              <span  style="color:white" >Enter A Customer Code.</span>
                            </ion-row>
                        </ion-col>
                        <ion-col  size="12" size-md="6" >
                            <ion-row>
                                <ion-input type="text"  [(ngModel)]="customerCode" class="ion-text-left color-light" placeholde="Leave blank for a list of all."></ion-input>
                              </ion-row>
                            
                        </ion-col>
                         <ion-col size="12" size-md="0.8"  >
                             <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="getCustomerProduct()" ><span>Show</span></ion-button>
                         </ion-col>  
                           </ion-row>
                </ion-grid>

            </ion-row>
    <div class="settings" style="padding-top:6%">
      <div style="padding-left:20px">
      <b>Settings:</b>
      <hr />

      <div class="form-section">
        <ion-row>
          <ion-col size="1.8">
             <label><b>Avail. Payment Methods:</b></label>
          </ion-col>
          <ion-col>
        <div class="checkbox-group">
         
          <label *ngFor="let method of paymentMethods" style="padding-right:10px">
            <input
              type="checkbox"
              name="payment_method"
              [value]="method.code"
              [(ngModel)]="method.isSelected"
              [ngModelOptions]="{ standalone: true }"
            />
            {{ method.description }}
          </label>
        </div>
        </ion-col>
        </ion-row>
      </div>

    <div class="form-section">
        <ion-row>
            <ion-col size="1.8">
                <label><b>Avail. Order Types:</b></label>
             </ion-col>
                <ion-col>
                <div class="checkbox-group">
                    <label *ngFor="let type of orderTypes"   style="padding-right:10px">
                        <input
                        type="checkbox"
                        name="type.shortName"
                        [value]="type.typeCode"
                        [(ngModel)]="type.isSelected"
                        [ngModelOptions]="{ standalone: true }"
                        />
                        {{ type.shortName }}
                    </label>
                </div>
            </ion-col>
        </ion-row>
    </div>
          <div class="form-actions">
          <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="saveCustSetting()" [disabled]="customerCode==''"><span>Save</span></ion-button>
      </div>
</div>
 <div class="product-table">
  <b>Available Products</b>

  <table class="custom-table">
    <thead>
      <tr>
        <th>Select</th>
        <th>Product Code</th>
        <th>Short Name</th>
        <th>Image File</th>
        <th>Customer Code</th>
        <th>Dept Code</th>
      </tr>
    </thead>
    <tbody>
    <tr *ngFor="let product of availableProducts">
  <!-- If shortName is NOT empty -->
  <ng-container *ngIf="product.shortName; else noShortName">
    <td>
      <a (click)="editCustomerProduct(product.customerCode, product.productCode, product.webCustCode)" class="link">
        {{ product.webCustCode === null ? 'Add' : 'Edit' }}
      </a>
    </td>
    <td>{{ product.productCode }}</td>
    <td>{{ product.shortName }}</td>
    <td>{{ product.imageFile }}</td>
    <td>{{ product.webCustCode }}</td>
    <td>{{ product.webDeptCode }}</td>
  </ng-container>

  <!-- Else block: shortName is empty -->
  <ng-template #noShortName>
    <td>
      <a (click)="editCustomerProduct(product.customerCode, product.productCode, product.webCustCode)" class="link">
        {{ product.webCustCode === null ? 'Add' : 'Edit' }}
      </a>
    </td>
    <td>{{ product.productCode }}</td>
      <td>{{ product.shortName }}</td>
    <td colspan="3">Not defined as Web Product. Click to <a href="javascript:void(0)" class="link" (click)="webProductEdit(product.productCode,3)" title="Add this Product to Web Products.">Here</a>  to Add</td>
  </ng-template>
</tr>
    </tbody>
  </table>
</div>

<div *ngIf="availableProducts?.length === 0"  style="padding-left:40%;color:red" class="alert alert-info mt-3">
  No Data found.
</div>


    </div>
       
   </ion-grid>
</ng-container>

</ion-content>
